import * as React from "react";
import type { SVGProps } from "react";

const SvgCalculator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={22}
    height={22}
    viewBox="0 0 22 22"
    {...props}
  >
    <defs>
      <path id="calculator_svg__a" d="M0 0h22v22H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="calculator_svg__b" fill="#fff">
        <use xlinkHref="#calculator_svg__a" />
      </mask>
      <path
        fill="#182744"
        d="M18 0H4C1.8 0 0 1.8 0 4v14c0 2.2 1.8 4 4 4h14c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4m0 1.5c1.378 0 2.5 1.122 2.5 2.5v14c0 1.379-1.122 2.5-2.5 2.5H4A2.503 2.503 0 0 1 1.5 18V4c0-1.378 1.122-2.5 2.5-2.5z"
        mask="url(#calculator_svg__b)"
      />
      <path
        stroke="#182744"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12.5 7.25H17m-4.5 6.139H17m-4.5 3.001H17M5 7.25h4.5M7.25 5v4.5M5.5 13.139 9 16.64m0-3.501L5.5 16.64"
      />
    </g>
  </svg>
);
export default SvgCalculator;
